import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import type { GraphQLError } from 'graphql';

export const preloadPersonalSpaceDetailsQuery: GraphQLTaggedNode = graphql`
	query preloadPersonalSpaceDetailsQuery {
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				space {
					id
					key
					dataClassificationTags
				}
			}
		}
	}
`;

export const preloadPersonalSpaceDetail = (): Promise<{
	data: unknown;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	return query({
		query: preloadPersonalSpaceDetailsQuery,
	});
};
